module.exports = __webpack_public_path__ + "img/faq-minus.cb8ff929.svg";